var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataPrivacyDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5062 21.3061C36.5062 24.9498 33.5834 27.8857 29.9997 27.8857C26.4161 27.8857 23.4933 24.9498 23.4933 21.3061C23.4933 17.6625 26.4161 14.7266 29.9997 14.7266C33.5834 14.7266 36.5062 17.6625 36.5062 21.3061Z",
    stroke: "#222222",
    strokeWidth: 2.18182
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9939 31.6019V31.602L30.0064 31.6019C32.1649 31.5895 35.5113 31.9139 38.2623 33.6313C40.871 35.26 43.0944 38.2325 43.0911 43.8578C42.9456 43.9464 42.663 44.0866 42.1516 44.2438C40.5622 44.7324 37.1514 45.272 30.0002 45.272C22.849 45.272 19.4382 44.7324 17.8488 44.2438C17.3374 44.0866 17.0547 43.9463 16.9093 43.8578C16.9052 38.2324 19.1286 35.26 21.7375 33.6314C24.4887 31.9139 27.8355 31.5895 29.9939 31.6019Z",
    stroke: "#222222",
    strokeWidth: 2.18182
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacyDefault);
export default __webpack_public_path__ + "static/media/data-privacy-default.5216d343d9c8d6db92c84b4dbd495587.svg";
export { ForwardRef as ReactComponent };